export class MainPageShowModel {
    constructor() {
        this.title = '';
        this.abstract = '';
        this.abstractTitle = '';
        this.picture = '';
        this.title = '';
        this.entrances = new Array<EntranceShowModel>();
        this.segments = new Array<SegmentShowModel>();

    }
    title: string;
    abstract: string;
    abstractTitle: string;
    picture: string;
    segments: SegmentShowModel[];
    entrances: EntranceShowModel[];
}

export class SegmentShowModel {
    constructor() {
        this.icon = '';
        this.link = '';
        this.priority = 0;
        this.titleTextContent = '';
        this.headerTextContent = '';
        this.bodyHTMLContent = '';
        this.buttonTextContent = '';

    }
    icon?: string;
    link?: string;
    priority?: number;
    titleTextContent?: string;
    headerTextContent?: string;
    bodyHTMLContent?: string;
    buttonTextContent?: string;
}
export class EntranceShowModel {
    constructor() {
        this.icon = '';
        this.priority = 0;
        this.position = '';
        this.titleTextContent = '';
        this.bodyHTMLContent = '';

    }
    icon?: string;
    priority?: number;
    position?: string;
    titleTextContent?: string;
    bodyHTMLContent?: string;
}
